import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { DataLine, H2, LargeOnly } from "commons";
import { format, FORMAT } from "commons/src/NuDateUtils";

export function PersonalDetails({
    details: {
        forename = "",
        surname = "",
        title = "",
        gender = "",
        maritalStatus = "",
        nationalities = "",
        employmentStatus = "",
        dateOfBirth = "",
        countryOfResidence = "",
        taxIdentifierNumbers = {}
    }
}) {
    const getTaxIdentifiers = (taxCountries, taxIdentifierNumbers) =>
        taxCountries
            .filter(country => taxIdentifierNumbers[country])
            .map(country => (
                <div key={country} data-testid="tax-identifier">
                    <DataLine
                        name={
                            (country === "United Kingdom"
                                ? "National Insurance Number / "
                                : "Tax Identifier Number / ") + country
                        }
                        value={taxIdentifierNumbers[country]}
                    />
                </div>
            ));

    const printList = list => (list ? list.join(", ") : null);

    const taxResidencies = Object.keys(taxIdentifierNumbers || {});
    return (
        <>
            <H2 secondary textAlign="center">
                Personal details
            </H2>
            <Fields>
                <DataLine name="Title" value={title} />
                <DataLine name="Forename" value={forename} />
                <DataLine name="Surname" value={surname} />
                <DataLine name="Sex" value={gender} />
                <DataLine name="Marital status" value={maritalStatus} />
                <DataLine
                    name="Date of Birth"
                    value={format(dateOfBirth, FORMAT.SLASH_SEPARATED)}
                />

                <LargeOnly>
                    <DataLine name="Nationalities" value={printList(nationalities)} />
                    <DataLine name="Tax residencies" value={printList(taxResidencies)} />
                </LargeOnly>

                {getTaxIdentifiers(taxResidencies, taxIdentifierNumbers)}

                <LargeOnly>
                    <DataLine name="Country of residence" value={countryOfResidence} />
                    <DataLine name="Employment status" value={employmentStatus} />
                </LargeOnly>
            </Fields>
        </>
    );
}

const Fields = styled.div`
    background: ${props => props.theme.tertiary};
    padding: 1.5em;
`;

PersonalDetails.propTypes = {
    details: PropTypes.shape({
        forename: PropTypes.string,
        surname: PropTypes.string,
        title: PropTypes.string,
        gender: PropTypes.string,
        maritalStatus: PropTypes.string,
        nationalities: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        employmentStatus: PropTypes.string,
        dateOfBirth: PropTypes.string,
        countryOfResidence: PropTypes.string,
        taxIdentifierNumbers: PropTypes.object
    })
};
